import Vue from 'vue';

import GridFilter from "./GridFilter";
import CurrentFilter from "./CurrentFilter";

Vue.component('brku-current-filter', CurrentFilter)
Vue.component('brku-grid-filter', GridFilter)